module.exports = __webpack_public_path__ + "img/timg.4fae7dfe.png";